<template>
  <div class="careers">
    <page-wrapper :videoConfig="videoConfig">
      <template v-slot:main>
        <p>We are always looking for talented people with tireless discipline and childlike curiosity.</p>
        <p>At POPULAR you will find state of the art circumstances to develop our company and your skills-set at the same time.</p>
        <p class="mb-5">Sounds great? Drop us a line at <a class="text-light" href="mailto:fast.lane@popular.de">fast.lane@popular.de</a> with a reason why and/or your portfolio.</p>

        <p class="text-center">
          <a class="btn btn-primary text-decoration-none"
             href="https://docs.google.com/document/d/1Kar3SzHNV7yCRXjL_GgNjE0LYcfg3VsGf1ll1XjPqlk/edit"
             target="_blank">Latest job offers</a>
        </p>
<!--        <p class="mb-4">Passionate people are our kind of people. We are always looking for talented and passionate creatives to join our team and our modern work culture.</p>-->
<!--        <p class="text-small">Want to shape the POPULAR brands of tomorrow with us?</p>-->
<!--        <p class="text-small">Whether you are looking for a full time position or to jump in as a freelancer, we want to get to know you and what moves you.</p>-->
        <!--        <b-tabs small nav-class="btabs" no-nav-style no-key-nav vertical>-->
        <!--          <b-tab title="Editor" active>-->
        <!--            <p>A A short text about the job description here would be nice to have but I don't know what to write at the momen and now just copy of the wirst part again to fill out text. One more line to fill here.</p>-->
        <!--            <p>A short text about the job description here would be nice to have but I don't know what to write at the momenshort text about the job description here would be nice. And not this it the last line.</p>-->
        <!--          </b-tab>-->
        <!--          <b-tab title="Producer"><p>Tab contents 2</p></b-tab>-->
        <!--          <b-tab title="Project Manager"><p>Tab contents 3</p></b-tab>-->
        <!--        </b-tabs>-->
      </template>
<!--      <template v-slot:footer>-->
<!--        <div class="row">-->
<!--          <div class="col">-->
<!--            <p>-->
<!--              <br><br>-->
<!--              <a href="mailto:contact@popular.de" class="text-large">Apply Here</a>-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
    </page-wrapper>
  </div>
</template>

<script>
  import PageWrapper from '@/components/PageWrapper'

  export default {
    name: 'Careers',
    components: {
      PageWrapper
    },
    data() {
      return {
        videoConfig: {
          srcL: require('../assets/video/POPULAR_Career_v6.mp4'),
          posterL: require('../assets/video/POPULAR_Career_v6.jpg'),
          srcM: require('../assets/video/POPULAR_Career_v6.mp4'),
          posterM: require('../assets/video/POPULAR_Career_v6.jpg'),
          srcS: require('../assets/video/POPULAR_Career_v6.mp4'),
          posterS: require('../assets/video/POPULAR_Career_v6.jpg')
        }
      }
    }
  }
</script>

<style>
  /*.careers .page {*/
  /*  background: url('../assets/POP_Website_Neo_Picture.jpg') no-repeat;*/
  /*  background-size: cover;*/
  /*}*/
  a.nav-link {
    color: #ffffff;
    padding: 0;
    margin-bottom: 10px;
    font-size: .9rem;
  }
  a.nav-link.active,
  a.nav-link:hover,
  a.nav-link:focus,
  a.nav-link[aria-selected='true'] {
    color: #ffffff;
    text-decoration: underline;
  }
  .tab-pane {
    font-size: .9rem;
  }
  .text-large {
    font-size: 2rem;
  }
  .text-small {
    font-size: 1rem;
    max-width: 90%;
  }
</style>
